import {Action} from 'redux'
import {WebsiteSectionBlockListModel, WebsiteSectionModel} from '../Model/WebsiteSectionModel'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialWebsiteSectionState: IWebsiteSectionState = {
  data: {
    websiteSection: [],
    meta: [],
  },
  sortWebsiteSectionData: [],
  websiteSectionList: {websiteSection: []},
  websiteBlockOption: [],
  deleteSuccess: false,
  enableSuccess: false,
  disableSuccess: false,
  singleEnableSuccess: false,
  singleDisableSuccess: false,
  loading: false,
  success: false,
}

export interface IWebsiteSectionState {
  data?: {
    websiteSection?: WebsiteSectionModel[]
    meta?: {[key: string]: string | number}[]
  }
  sortWebsiteSectionData?: IWebsiteSectionState[]
  websiteSectionList?: {websiteSection: WebsiteSectionModel[]}
  websiteBlockOption: WebsiteSectionBlockListModel[]
  deleteSuccess?: boolean
  enableSuccess?: boolean
  disableSuccess?: boolean
  singleEnableSuccess?: boolean
  singleDisableSuccess?: boolean
  loading?: boolean
  success?: boolean
}

export const reducer = (
  state: IWebsiteSectionState = initialWebsiteSectionState,
  action: ActionWithPayload<IWebsiteSectionState>
) => {
  switch (action.type) {
    case actionTypes.GET_ALL_WEBSITE_SECTION_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_ALL_WEBSITE_SECTION_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        websiteSectionList: action.payload,
        loading: false,
      }
    }

    case actionTypes.GET_ALL_WEBSITE_SECTION_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //GET WebsiteSection DATA
    case actionTypes.GET_WEBSITE_SECTION_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_WEBSITE_SECTION_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_WEBSITE_SECTION_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //GET  WebsiteBlock list
    case actionTypes.GET_WEBSITE_BLOCK_OPTION_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_WEBSITE_BLOCK_OPTION_SUCCESS: {
      return {
        ...state,
        websiteBlockOption: action.payload,
        loading: false,
      }
    }

    case actionTypes.GET_WEBSITE_BLOCK_OPTION_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Add WebsiteSection
    case actionTypes.ADD_WEBSITE_SECTION_START: {
      return {...state, loading: true}
    }

    case actionTypes.ADD_WEBSITE_SECTION_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.ADD_WEBSITE_SECTION_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.RESET_WEBSITE_SECTION: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    //Update WebsiteSection
    case actionTypes.UPDATE_WEBSITE_SECTION_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_WEBSITE_SECTION_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_WEBSITE_SECTION_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Delete
    case actionTypes.DELETE_WEBSITE_SECTION_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_WEBSITE_SECTION_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_WEBSITE_SECTION_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    //Enable
    case actionTypes.ENABLE_WEBSITE_SECTION_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.ENABLE_WEBSITE_SECTION_SUCCESS: {
      return {
        ...state,
        enableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.ENABLE_WEBSITE_SECTION_FINISH: {
      return {
        ...state,
        loading: false,
        enableSuccess: false,
      }
    }

    //disable
    case actionTypes.DISABLE_WEBSITE_SECTION_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.DISABLE_WEBSITE_SECTION_SUCCESS: {
      return {
        ...state,
        disableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DISABLE_WEBSITE_SECTION_FINISH: {
      return {
        ...state,
        loading: false,
        disableSuccess: false,
      }
    }
    //Enable
    case actionTypes.SINGLE_ENABLE_WEBSITE_SECTION_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_ENABLE_WEBSITE_SECTION_SUCCESS: {
      const changedData: any = action.payload?.data?.websiteSection
      let newData = state?.data?.websiteSection?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })
      return {
        ...state,
        data: {...state, meta: state?.data?.meta, websiteSection: newData},
        singleEnableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_ENABLE_WEBSITE_SECTION_FINISH: {
      return {
        ...state,
        singleEnableSuccess: false,
        toggleLoading: false,
      }
    }

    //Disable
    case actionTypes.SINGLE_DISABLE_WEBSITE_SECTION_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_DISABLE_WEBSITE_SECTION_SUCCESS: {
      const changedData: any = action.payload?.data?.websiteSection
      let newData = state?.data?.websiteSection?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })

      return {
        ...state,
        data: {...state, meta: state?.data?.meta, websiteSection: newData},
        singleDisableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_DISABLE_WEBSITE_SECTION_FINISH: {
      return {
        ...state,
        singleDisableSuccess: false,
        toggleLoading: false,
      }
    }

    // sort
    case actionTypes.SORT_WEBSITE_SECTION_START: {
      return {...state, loading: true}
    }

    case actionTypes.SORT_WEBSITE_SECTION_SUCCESS: {
      return {
        ...state,
        sortWebsiteSectionData: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.SORT_WEBSITE_SECTION_FINISH: {
      return {
        ...state,
        loading: false,
        success: false,
      }
    }

    case actionTypes.SORT_WEBSITE_SECTION_RESET: {
      return {
        ...state,
        loading: false,
        success: false,
        sortWebsiteSectionData: [],
      }
    }

    default:
      return state
  }
}
